import { render, staticRenderFns } from "./SubmitApprovalModal.vue?vue&type=template&id=499aca8d"
import script from "./SubmitApprovalModal.vue?vue&type=script&lang=js"
export * from "./SubmitApprovalModal.vue?vue&type=script&lang=js"
import style0 from "./SubmitApprovalModal.vue?vue&type=style&index=0&id=499aca8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports